import { useState } from 'react';

import TextInputMaskedServerError from '@perpay-web/components/higher-order/WithFieldServerErrors/TextInputMaskedServerError';
import { ssn as ssnValidation } from '@perpay-web/fintech/validators/fieldBased';
import { getClassName } from '@perpay-web/utils/domUtils';
import { noop } from '@perpay-web/utils/noop';

import styles from './SsnInput.scss';

// New formik-agnostic version compatible with FormikContext
// Todo: delete SsnInput component after replaced in PHO application with this version
const SsnInput = ({
    value = '',
    name = 'ssn',
    label = 'SSN',
    className = '',
    onFocus = noop,
    onBlur = noop,
    hideIcon = false,
    ...rest
}) => {
    const [ssnFocused, setSsnFocused] = useState(false);

    // Convenience method returning boolean for ssn validity (validation returns truthy error if invalid, else undefined if valid)
    const ssnValid = (ssn) => !ssnValidation(ssn.replace(/\D*/g, ''));

    const getIsSsnFirstFiveHidden = (ssn) => !ssnFocused && ssnValid(ssn);

    const formatMaskedSsn = (val) => val.slice(-4);

    const ssnOnFocus = (e) => {
        setSsnFocused(true);
        onFocus(e);
    };

    const ssnOnBlur = (e) => {
        setSsnFocused(false);
        onBlur(e);
    };

    const renderIcon = () => (
        <span className={getClassName(styles['lock-icon'])} />
    );

    return (
        <TextInputMaskedServerError
            className={getClassName(styles.input, className)}
            name={name}
            label={label}
            type='tel'
            format={
                getIsSsnFirstFiveHidden(value) ? 'XXX-XX-####' : '###-##-####'
            }
            mask='x'
            onFocus={ssnOnFocus}
            onBlur={ssnOnBlur}
            value={
                getIsSsnFirstFiveHidden(value) ? formatMaskedSsn(value) : value
            }
            icon={hideIcon ? null : renderIcon()}
            {...rest}
        />
    );
};

export default SsnInput;
